<template>
    <transition
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="opened"
            class="sticky top-0 z-40 flex items-center gap-3 border-b border-new-amber-200 bg-new-amber-50 px-4 py-3 mt-3"
        >
            <TriangleAlert class="size-5 shrink-0 text-new-amber-600" />

            <div class="flex-1 text-sm">
                <template v-if="type === 'pro'">
                    <span class="font-medium text-new-amber-900">
                        Your free 14-day trial ended
                        <span v-if="date">on {{ format(new Date(date), 'MMMM d, yyyy') }}</span>.
                    </span>
                    <span class="text-new-amber-700">
                        You are now on the Free plan. Subscribe to continue using TOPOL Pro.
                    </span>
                </template>
                <template v-if="type === 'plugin'">
                    <span class="font-medium text-new-amber-900">
                        Your free Plugin 14-day trial ended
                        <span v-if="date">on {{ format(new Date(date), 'MMMM d, yyyy') }}</span>.
                    </span>
                    <span class="text-new-amber-700">
                        Your API Tokens are suspended. Subscribe to continue.
                    </span>
                </template>
            </div>

            <div class="flex items-center gap-2 shrink-0">
                <Button size="sm" @click="handleSubscribe">
                    Subscribe now
                </Button>
                <Button variant="ghost" size="icon" class="size-8 text-new-amber-700 hover:text-new-amber-900 hover:bg-new-amber-100" @click="opened = false">
                    <X class="size-4" />
                </Button>
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from 'ziggy-js'
import { format } from 'date-fns'
import { TriangleAlert, X } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

const props = defineProps<{
    type: 'pro' | 'plugin'
    date: string | undefined
}>()

const opened = ref(true)

const handleSubscribe = () => {
    if (props.type === 'pro') {
        router.visit(route('billing.pro-subscriptions.index'))
    } else {
        router.visit(route('billing.plugin-subscriptions.index'))
    }
}
</script>
